import { css } from '~/styled-system/css'

export function IkyuDayBalloon() {
  return (
    <div className={css({ position: 'relative' })}>
      <div
        className={css({
          display: 'inline-flex',
          justifyContent: 'center',
          fontSize: 'xs',
          fontWeight: 'bold',
          textWrap: 'nowrap',
          lineHeight: '[12.5px]',
          color: 'not.recommended.ikyu.carrot.dark',
          position: 'absolute',
          bottom: '[calc(100% + 6px)]',
          left: '[50%]',
          transform: 'translate(-50%, 0)',
          borderWidth: 'thin',
          borderColor: 'not.recommended.ikyu.carrot.light',
          borderRadius: 'sm',
          bgColor: 'white',
          p: '1',
          _after: {
            content: '" "',
            position: 'absolute',
            bottom: '0',
            left: '[50%]',
            width: '[6px]',
            height: '[6px]',
            bgColor: 'white',
            borderColor: 'not.recommended.ikyu.carrot.light',
            borderRight: '[1px solid]',
            borderBottom: '[1px solid]',
            transform: 'translate(-50%, 3.5px) rotate(45deg)',
            transformOrigin: 'center center',
          },
        })}
      >
        今なら最大<span className={css({ fontSize: 'sm' })}>1,000</span>円分！
      </div>
    </div>
  )
}
